/**
 * POLYFILLS FILE
 *
 * This file exports a function which applies all required polyfills in order
 * for the app to work.
 *
 * @version 0.1
 */


/**
 * Babel polyfill for full ES6 support.
 */
export let babelPolyfill = () => {

    if(typeof _babelPolyfill === 'undefined') {
        require('babel-polyfill');
    }
    
};

/**
 * NodeList forEach polyfill for browser support
 */
export let nodeListPolyfill = () => {
    if ('NodeList' in window && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = (callback, thisArg) => {
            thisArg = thisArg || window;

            for (let i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }
};

/**
 * The Intl polyfill is required by older browsers and also Safari in order
 * for the react-intl (internationalization module) to work properly.
 */
export let intl = () => { if (!window.Intl) { window.Intl = require('intl'); } };


/**
 * Applies all polyfills
 */
export default function applyAllPolyfills() {

    babelPolyfill();
    nodeListPolyfill();
    intl();

}


// WEBPACK FOOTER //
// ./src/scripts/utils/polyfills.js